import * as Comlink from "comlink";

/** Comlink.windowEndpoint's targetOrigin only constrains outgoing messages.
 * Filter incoming RPCs too; otherwise unrelated windows can invoke exposed API
 * methods even though replies are sent to the intended frame. */
export function boundWindowEndpoint(
  remote: Window,
  local: Window,
  origin: string,
): Comlink.Endpoint {
  const endpoint = Comlink.windowEndpoint(remote, local, origin);
  const listeners = new Map<
    EventListenerOrEventListenerObject,
    EventListener
  >();
  return {
    postMessage: endpoint.postMessage.bind(endpoint),
    addEventListener(type, listener, options) {
      if (type !== "message")
        return endpoint.addEventListener(type, listener, options);
      let wrapped = listeners.get(listener);
      if (!wrapped) {
        wrapped = (event) => {
          const message = event as MessageEvent;
          if (message.source !== remote || message.origin !== origin) return;
          if (typeof listener === "function") listener.call(local, event);
          else listener.handleEvent(event);
        };
        listeners.set(listener, wrapped);
      }
      return endpoint.addEventListener(type, wrapped, options);
    },
    removeEventListener(type, listener, options) {
      if (type !== "message")
        return endpoint.removeEventListener(type, listener, options);
      const wrapped = listeners.get(listener);
      if (wrapped) {
        endpoint.removeEventListener(type, wrapped, options);
        listeners.delete(listener);
      }
    },
  };
}
